import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-951dcc18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-notice__icon"
}

import TextLabel from "@/components/UI/TextLabel.vue";
interface Props {
	severity?: 'notice'|'error';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TextNotice',
  props: {
    severity: {}
  },
  setup(__props: any) {

const props = __props;

const cssClasses = () => {
	const classes = [
		'text-notice'
	];

	if (props.severity) {
		classes.push(`text-notice--${props.severity}`);
	}

	return classes;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(cssClasses())
  }, [
    (_ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "icon")
        ]))
      : _createCommentVNode("", true),
    _createVNode(TextLabel, null, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    })
  ], 2))
}
}

})